import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.io = bracketIndenting()
